import { TBidTag } from '@northladder/services';

import { cn } from '../../../../lib';
import { Badge } from '../../../../ui/badge-cn';

import { getRankBadgeOptionsFromTag } from './config';
import { useBidRankTranslations } from './useBidRankTranslations';

interface IBidRankBadgeProps {
  rank: TBidTag;
}

/**
 * -----------------------------------------------------------------------------
 * BidRankBadge component displays the bid rank.
 */
export function BidRankBadge({ rank }: IBidRankBadgeProps) {
  const { label } = useBidRankTranslations(rank);

  const { className, Icon } = getRankBadgeOptionsFromTag(rank);

  return (
    <Badge
      className={cn(
        'text-text-caption border-rank-border space-x-2 rounded-lg border px-2 py-1.5',
        className
      )}
      variant="secondary"
    >
      <Icon />
      {label}
    </Badge>
  );
}
